// MOCK DATA - replaced by backend API later (see contracts.md)

export const CATEGORIES = [
  'Fat Loss & Metabolism',
  'Skin & Beauty',
  'Repair & Recovery',
  'Focus & Mood',
  'Specialty Research',
  'Research Support',
];

export const RESEARCH_DISCLAIMER =
  'All products are supplied strictly for research purposes only. Not for human consumption. Not intended to diagnose, treat, cure or prevent any disease. No medical claims are made. By purchasing, the customer confirms they understand and accept these terms.';

export const AU_STATES = [
  { code: 'NSW', name: 'New South Wales' },
  { code: 'VIC', name: 'Victoria' },
  { code: 'QLD', name: 'Queensland' },
  { code: 'WA', name: 'Western Australia' },
  { code: 'SA', name: 'South Australia' },
  { code: 'TAS', name: 'Tasmania' },
  { code: 'ACT', name: 'Australian Capital Territory' },
  { code: 'NT', name: 'Northern Territory' },
];

const IMG = {
  v1: 'https://images.unsplash.com/photo-1669350350450-e7d42d85fcd2?w=800&q=80',
  v2: 'https://images.unsplash.com/photo-1574670700790-fa314ab37787?w=800&q=80',
  v3: 'https://images.unsplash.com/photo-1576671081803-5dcb9836dc61?w=800&q=80',
  v4: 'https://images.unsplash.com/photo-1655174041849-49ed985e9ffb?w=800&q=80',
};

export const HERO_IMG =
  'https://images.unsplash.com/photo-1531956656798-56686eeef3d4?w=1600&q=80';

export const MOCK_PRODUCTS = [
  {
    id: 'p1', name: 'BPC-157', code: 'BPC', size: '5mg', price: 65.0,
    image: IMG.v1, category: 'In Stock', stockStatus: 'In Stock', coa: true,
    featured: true,
    description: 'Research-grade BPC-157, 5mg lyophilised powder. HPLC verified to 98%+ purity. Third-party tested with COA available on request.',
  },
  {
    id: 'p2', name: 'TB-500', code: 'TB5', size: '5mg', price: 70.0,
    image: IMG.v2, category: 'In Stock', stockStatus: 'In Stock', coa: true,
    featured: true,
    description: 'Research-grade TB-500 (Thymosin Beta-4 fragment), 5mg lyophilised powder. HPLC verified 98%+ purity. COA available.',
  },
  {
    id: 'p3', name: 'GHK-Cu', code: 'GHK', size: '50mg', price: 85.0,
    image: IMG.v3, category: 'In Stock', stockStatus: 'In Stock', coa: true,
    featured: true,
    description: 'Copper Peptide GHK-Cu, 50mg lyophilised powder. Research-grade, third-party verified purity. COA available.',
  },
  {
    id: 'p4', name: 'NAD+', code: 'NAD', size: '100mg', price: 95.0,
    image: IMG.v4, category: 'In Stock', stockStatus: 'In Stock', coa: true,
    featured: true,
    description: 'NAD+ 100mg lyophilised powder. High-purity research-grade compound. COA available on request.',
  },
  {
    id: 'p5', name: 'Semaglutide', code: 'SEMA', size: '5mg', price: 120.0,
    image: IMG.v2, category: 'Preorder', stockStatus: 'Preorder', coa: true,
    featured: false,
    description: 'Research-grade Semaglutide, 5mg. Preorder item. ETA usually 14\u201321 days after weekly supplier order. COA available.',
  },
  {
    id: 'p6', name: 'Tirzepatide', code: 'TIRZ', size: '10mg', price: 165.0,
    image: IMG.v1, category: 'Preorder', stockStatus: 'Preorder', coa: true,
    featured: false,
    description: 'Research-grade Tirzepatide, 10mg. Preorder item. ETA usually 14\u201321 days after weekly supplier order. COA available.',
  },
  {
    id: 'p7', name: 'CJC-1295 / Ipamorelin Blend', code: 'CJC-IPA', size: '10mg', price: 110.0,
    image: IMG.v3, category: 'Blends', stockStatus: 'In Stock', coa: true,
    featured: true,
    description: 'Pre-blended CJC-1295 / Ipamorelin research compound, 10mg total. HPLC verified. COA available.',
  },
  {
    id: 'p8', name: 'BPC-157 / TB-500 Blend', code: 'BPC-TB', size: '10mg', price: 125.0,
    image: IMG.v4, category: 'Blends', stockStatus: 'In Stock', coa: true,
    featured: false,
    description: 'Pre-blended BPC-157 / TB-500 research compound, 10mg total. Third-party verified purity. COA available.',
  },
  {
    id: 'p9', name: 'Bacteriostatic Water', code: 'BAC', size: '10ml', price: 15.0,
    image: IMG.v3, category: 'Research Support', stockStatus: 'In Stock', coa: false,
    featured: false,
    description: 'Bacteriostatic water, 10ml. Research support consumable for reconstitution of lyophilised research compounds.',
  },
  {
    id: 'p10', name: 'Insulin Syringes (Box of 100)', code: 'SYR', size: '1ml / 29G', price: 25.0,
    image: IMG.v2, category: 'Accessories', stockStatus: 'In Stock', coa: false,
    featured: false,
    description: 'Box of 100 sterile 1ml syringes for laboratory handling and measurement of research compounds.',
  },
  {
    id: 'p11', name: 'Alcohol Prep Swabs (Box of 200)', code: 'SWAB', size: '200pk', price: 12.0,
    image: IMG.v1, category: 'Accessories', stockStatus: 'In Stock', coa: false,
    featured: false,
    description: 'Box of 200 sterile alcohol prep swabs for laboratory surface and vial preparation.',
  },
  {
    id: 'p12', name: 'MOTS-c', code: 'MOTS', size: '10mg', price: 130.0,
    image: IMG.v4, category: 'In Stock', stockStatus: 'Out of Stock', coa: true,
    featured: false,
    description: 'Research-grade MOTS-c, 10mg lyophilised powder. Currently out of stock \u2014 check back soon or enquire about preorder.',
  },
];

export const FAQS = [
  { q: 'What does \u201cresearch purposes only\u201d mean?', a: 'All products listed are supplied strictly for laboratory and research use. They are not for human consumption and are not intended to diagnose, treat, cure or prevent any disease. No medical claims are made.' },
  { q: 'Do you ship Australia-wide?', a: 'Yes. We ship to all Australian states and territories. We do not ship internationally.' },
  { q: 'Are items in stock?', a: 'Yes \u2014 we hold our full range in stock. Orders are dispatched promptly, typically within 1\u20132 business days of payment confirmation.' },
  { q: 'What if an item is out of stock?', a: 'It will simply show as out of stock on the shop until the next batch lands. Keep an eye on the site or contact us and we\u2019ll let you know when it\u2019s back.' },
  { q: 'How long does shipping take?', a: 'Orders are dispatched promptly from Australian stock \u2014 typically within 1\u20132 business days of payment confirmation \u2014 and sent via Australia Post Express Post.' },
  { q: 'Do you provide COAs?', a: 'COAs (Certificates of Analysis) are available where supplied. Products marked \u201cCOA Available\u201d include third-party verification on request.' },
  { q: 'What do I need to run a research kit?', a: 'A complete research kit is made up of four things: a vial of your chosen peptide, BAC (bacteriostatic) water for reconstitution, insulin syringes, and alcohol wipes. All four are sold separately on the site — but as a thank-you, every order automatically ships with 4 alcohol wipes and 4 syringes included free, so smaller kits are covered out of the box.' },
  { q: 'What payment methods are accepted?', a: 'You can pay by bank transfer, credit/debit card, or Afterpay (both processed securely through Square). All prices are in AUD. Your order is received immediately but is not confirmed until payment has been received. Once payment is confirmed, your order status is updated.' },
  { q: 'Is there a transaction fee on card and Afterpay payments?', a: 'No. We absorb all card and Afterpay processing fees ourselves \u2014 the price you see at checkout is exactly what you pay, whichever payment method you choose.' },
  { q: 'Are refunds available?', a: 'No refunds or returns are available once payment is completed. By purchasing, you acknowledge and accept this.' },
];
